import { createTestIds } from '@pega/cosmos-react-core';

export const openGraphPreviewElements = ['content', 'image'] as const;

export const getOpenGraphPreviewTestIds = createTestIds(
  'open-graph-preview',
  openGraphPreviewElements
);
